import { combineEpics, ofType } from 'redux-observable';
import { EMPTY, from } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Action } from '../actions';
import {
    KeywordsEditorActionType,
    KeywordsEditorFetchStatAction,
    keywordsEditorUpdateStat
} from '../actions/keywordsEditor';
import { GetPhrasesStatsResponsePhrase } from '../api/RestApiManager';
import { mapKeywordDataToString } from '../service/PhrasesHelpers/PhrasesHelpers';
import { DnaEpic, DnaEpicAction } from '../typings/epic';

const keywordsEditorFetchStatEpic: DnaEpic = (action$, store$, deps) => {
    return action$.pipe(
        ofType(KeywordsEditorActionType.FETCH_STAT),
        switchMap(
            (action: KeywordsEditorFetchStatAction): DnaEpicAction => {
                const { groupInfo, editorId } = action;
                const { value } = store$.value.keywordsEditor.editors[editorId];
                return from(
                    deps.restApiManager.getPhrasesStats({
                        adGroupType: groupInfo.groupType,
                        phrases: value.map(mapKeywordDataToString),
                        commonMinusPhrases: groupInfo.minusKeywords,
                        geo: groupInfo.regionIds,
                        campaignId: groupInfo.campaign.id,
                        libraryMinusPhrasesIds: groupInfo.minusKeywordsLibraryList
                    })
                ).pipe(
                    map(
                        (data: Array<GetPhrasesStatsResponsePhrase>): Action =>
                            keywordsEditorUpdateStat(editorId, data.map(item => item.shows))
                    ),
                    catchError((): DnaEpicAction => EMPTY)
                );
            }
        )
    );
};

export const keywordsEditorEpic = combineEpics(keywordsEditorFetchStatEpic);
